import React from "react";
import Preloader from "../../Global/Preloader";
import Headertwo from "../../Global/Headertwo";
import Faqbreadcumb from "../../Global/Faqbreadcumb";
import Teamdetail from "../MenFaq/Teamdetails";
import Ctaone from "../../Global/Ctaone";
import Footertwo from "../../Global/Footertwo";
import BackToTop from '../../Global/BackToTop';
import Footer from '../../Global/Footer';
import Innerpage1 from "../../Pages/MenAboutus/Innerpage1";

const Faq = () => {
    return(
        <>
        {/* <Preloader/> */}
         <Headertwo/>
         <Innerpage1/>
         {/* <Teamdetail/> */}
         <Ctaone/>
         <Footer/>
         <BackToTop/>
        </>
    )
}
export default Faq;